import React, { useEffect } from 'react';
import { useStore } from '../../../../../../stores/root';
import styles from './styles.module.scss';

// assets

// services

// props

// components
import { SpinnerSize, Stack } from '@fluentui/react';
import Text from '../../../../../typography/text';
import LoadingComponent from '../../../../../feedbacks/loading';
import Label from '../../../../../typography/label';
import GeneralService from '../../../../../../services/general';
import { IOutcomeResourceShorterProps } from '../../../../../../props/finance/outcomes';

type TotalOutcomeInvoiceUnpaidAmountCardProps = {
    style?: any;
    grow?: number | boolean | "inherit" | "initial" | "unset" | undefined;
    variant?: 'primary' | 'default';
    invoices?: IOutcomeResourceShorterProps[];
}

const TotalOutcomeInvoiceUnpaidAmountCard: React.FC<TotalOutcomeInvoiceUnpaidAmountCardProps> = (props: TotalOutcomeInvoiceUnpaidAmountCardProps) => {
    const { banner } = useStore();
    const [unpaidAmount, setUnpaidAmount] = React.useState<number>();

    useEffect(() => {
        calculateUnpaidAmount();
    }, [props.invoices]);

    const calculateUnpaidAmount = () => {
        let totalAmount = 0;

        (props.invoices || []).forEach((invoice) => {
            totalAmount += Number(invoice.unpaid || '0');
        })

        setUnpaidAmount(totalAmount);
    }

    return <Stack grow={props.grow} tokens={{ childrenGap: 20 }} className={`${styles.card} ${styles.variant}`} style={props.style}>
        <Stack>
            <Label size={'small'}>Unpaid amount</Label>
        </Stack>
        <Stack>
            {!props.invoices ? <LoadingComponent labelPosition='right' label={'Retrieving ...'} spinnerPosition={'baseline'} size={SpinnerSize.small} /> : null}
            {props.invoices ? <>
                <Label className={'color-red'} size={'large'}>Rp. {GeneralService.getNumberWithSeparator(unpaidAmount + '')}</Label>
            </> : null}
        </Stack>
    </Stack>;
};

export default TotalOutcomeInvoiceUnpaidAmountCard;
